/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { combineEpics } from 'redux-observable';

import { fetchFarthestAvailability } from './fetchFarthestAvailability';
import { fetchFacilityData } from './fetchFacilityData';
import { fetchRecAreaData } from './fetchRecAreaData';
import { fetchToursByFacility } from './fetchToursByFacility';
import { fetchTourImagesByFacility } from './fetchTourImagesByFacility';
import { fetchTourRatingsByFacility } from './fetchTourRatingsByFacility';
import { fetchPricingView } from './fetchPricingView';
import { fetchAvailabilityByFacility } from './fetchAvailabilityByFacility';
import { fetchTourTimes } from './fetchTourTimes';
import { fetchAvailabilityByTour } from './fetchAvailabilityByTour';

export const rootEpic = combineEpics(
    fetchFarthestAvailability,
    fetchFacilityData,
    fetchRecAreaData,
    fetchToursByFacility,
    fetchTourImagesByFacility,
    fetchTourRatingsByFacility,
    fetchPricingView,
    fetchAvailabilityByFacility,
    fetchTourTimes,
    fetchAvailabilityByTour
);
